<template>
  <div class="status_box">
    <h1>{{ getTranslations.home_profile_profile_stats_your_status }}</h1>

      <div class="status_numbs ">
        {{ formattedValue(userDetails.totalPointsEarned) }}   </div>
      <div class="status_txts">{{ getTranslations.home_profile_profile_points }}</div>
      <hr>
      <div class="status_numbs ">
      {{ numberFormatting(userDetails.achievements) }}   </div>
      <div class="status_txts">{{ getTranslations.home_profile_profile_achievements }}</div>
      <hr>
      <div class="status_numbs ">
        {{ formattedValue(userDetails.gamesPlayed) }}   </div>
      <div class="status_txts">{{ getTranslations.home_profile_profile_games }}</div>
      <hr>
      <div class="status_numbs ">
        {{ formattedValue(userDetails.availableGames) }}   </div>
      <div class="status_txts">{{ getTranslations.home_profile_profile_game_unlocked }}</div>
      <hr>
      <div class="home_stats">
      <p> </p>
      <label>   <router-link v-if="!hideStore" to="/home/store" class="more_games">{{ getTranslations.home_profile_profile_leaderboard }}</router-link>
      </label>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import NumbersFormattingMixin from '@/common/mixins/numbersFormatting';

export default {
  name: 'profile-stats',
  mixins: [NumbersFormattingMixin],
  methods: {
    formattedValue(intValue) {
      if (this.integrationHeader === this.availableIntegrations.KOREK_IRAQ.name) {
        return intValue.toLocaleString();
      }
      return intValue;
    },
  },
  computed: {
    ...mapState('common', [
      'userDetails',
      'availableIntegrations',
      'integrationHeader',
      'hideStore',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
  ...mapState('game', [
    'playersDetails',
  ]),
};
</script>



// WEBPACK FOOTER //
// src/components/home/profile/ProfileStats.vue